import { Box, Typography, useTheme } from '@mui/material';
import Divider from 'components/divider';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import RecommendationActions from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-actions';
import RecommendationCardInfo from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-card-info';
import RecommendationProductsList from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/recommendations/recommendation-products-list';
import { Recommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

type Props = {
  recommendation: Recommendation;
};

const StandardRecommendationRowBody: React.FC<Props> = ({ recommendation }) => {
  const theme = useTheme();

  return (
    <Box paddingBottom={4} display={'flex'} flexDirection={'column'} gap={4}>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        sx={{
          border: `1px solid ${theme.palette.darkBlue.o25}`,
          borderRadius: 1,
        }}
        padding={2}
        marginBottom={2}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={2}
          padding={2}
          width={'35%'}
          sx={{
            borderRight: `1px solid ${theme.palette.darkBlue.o25}`,
          }}>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.orderDetails`} />
            </Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.vesselName`} />:
            </Typography>
            <Typography fontSize={14} whiteSpace={'nowrap'}>
              {recommendation.vessel}
            </Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.plantName`} />:
            </Typography>
            <Typography fontSize={14} whiteSpace={'nowrap'}>
              {recommendation.plantName}
            </Typography>
          </Box>
        </Box>

        <RecommendationProductsList recommendation={recommendation} />
      </Box>

      <RecommendationCardInfo recommendation={recommendation} />
      <Divider
        sx={{
          m: theme.spacing(2, 0, 4, 0),
          borderColor: theme.palette.darkBlue.o25,
          width: '100%',
        }}
      />
      <RecommendationActions recommendation={recommendation} />
    </Box>
  );
};

export default React.memo(StandardRecommendationRowBody);
